import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseToolbarFeature from '../../../common/feature/base-toolbar-feature';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { transaction } from '@src/slide/domain/slide-app';

@Feature()
export class ResetPictureFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;

    public resetPicture(needResetSize: boolean) {
        transaction(() => {
            const model = this.getSelectionService().getSelectedModel();
            const selectedModels = getAllChildModels(model as IElementBaseModel);
            selectedModels.forEach((model) => {
                if (model.type === UIModelType.IMAGE) {
                    (model as IPictureModel).handleResetPicture(needResetSize);
                } else if (model.type === UIModelType.SHAPE) {
                    (model as IShapeModel).getImageFillEffect()?.handleResetPicture();
                }
            });
        });
    }
}
